<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.275 3.54971L4.5375 8.79971C3.4125 9.67471 2.5 11.5372 2.5 12.9497V22.2122C2.5 25.1122 4.8625 27.4872 7.7625 27.4872H22.2375C25.1375 27.4872 27.5 25.1122 27.5 22.2247V13.1247C27.5 11.6122 26.4875 9.67472 25.25 8.81222L17.525 3.39971C15.775 2.17471 12.9625 2.23721 11.275 3.54971Z" stroke="#2C2738" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15 22.4883V18.7383" stroke="#2C2738" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
import iconMixin from "@/services/iconMixins.js";

export default {
  mixins: [iconMixin]
};
</script>
